__webpack_require__.p = "https://assets-dev.nextorder.co/build-assets/dev-build-2026-07-08-1783517428-stable-dev/";